export default "__VITE_ASSET__Dh4Dseo9__"